import React, { useState, useEffect } from 'react';
import { Card } from 'react-bootstrap';
import { Form} from 'react-bootstrap';
import useFormGenerator from '../../common/FormUtils';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import useButtonsGenerator from '../../common/functions/useButtonsGenerator';
import { useParams } from 'react-router-dom';
import FormModal from '../../common/FormModal';
import RoomService from './RoomService';

import schema from './jsonSchema';
const jsonSchema = schema;

const RoomForm = () => {
  const { identifier } = useParams();
  const [data, setData] = useState();
  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    if (undefined !== identifier) {
      RoomService.retrieveRoom(identifier)
        .then(data => {
          const updatedData = {
            ...data,
            facilities: data.facilities ? data.facilities.map(f => ({ value: f, label: f })) : []
          };  
          setData(updatedData);
        })
        .catch(error => console.log(error));
    }
  }, [identifier]);
const handleRoomFormSubmit = formData => {
  RoomService.saveRoom(formData)
    .then(response => {console.log(response); setModalShow(true)})
    .catch(error => console.log(error));
};

  const buttonsConf = [
    {
      name: 'Save Room',
      type: 'submit',
      variant: 'info',
      onClick: () => {
        console.log('Save Room');
      }
    }
  ];
  const title = identifier ? 'Edit Room' : 'Create Room';
  const description = identifier ? 'Edit the details of your Room' : 'Fill in the details of your new Room';
  const headerGenerated = useHeaderGenerator(
    title,
    description,
    []
  );

  return (
    <>
      {headerGenerated}
      {modalShow && <FormModal message={'Room  has been updated!'} modalShow={modalShow} setModalShow={setModalShow}/>}
      <Card>
        <Card.Body>
            {data || undefined === identifier ? (
            // Pass data to the form generator hook
            <FormGeneratorWithData data={data} buttonsConf={buttonsConf} onSubmit={handleRoomFormSubmit}/>
            ) : (
                <p>Loading...</p>
            )}
        </Card.Body>
      </Card>
    </>
  );
};
const FormGeneratorWithData = ({ data, buttonsConf, onSubmit }) => {

    const [validated, setValidated] = useState(false);
    const buttonsGenerated = useButtonsGenerator(buttonsConf);
    // Use the useFormGenerator hook with the provided data
    const { formFields, handleSubmit, handleChange } = useFormGenerator(
      jsonSchema,
      onSubmit,
      data,
      setValidated
    );
  
    // Render your form using the formFields and event handlers
    return (
        <Form
        className="mb-2"
        noValidate
        validated={validated}
        onSubmit={handleSubmit}
      >
        {formFields}
        <Card.Footer>{buttonsGenerated}</Card.Footer>
      </Form>
    );
  };
export default RoomForm;